export interface ChatNotificationItem {
  messageId: string;
  channelId: string;
  title: string;
  body: string | null;
  createdAt: string;
}

/**
 * FCM data payload(고객 채팅 push)를 알림 리스트 아이템으로 변환한다.
 * 서버 `buildFCMPayloadFromChannelMessage`가 다음 필드를 보장한다:
 * - data.messageId, data.channelId, data.title, data.body, data.createdAt
 */
export interface ChatPushPayloadData {
  messageId?: string;
  channelId?: string;
  title?: string;
  body?: string;
  createdAt?: string;
}

export const fromChatPushPayload = (
  data: ChatPushPayloadData,
  fallback: { now: string },
): ChatNotificationItem | null => {
  const channelId = data.channelId;
  const messageId = data.messageId;
  if (!channelId || !messageId) return null;
  return {
    messageId,
    channelId,
    title: data.title ?? '새 고객 메시지',
    body: data.body ?? null,
    createdAt: data.createdAt ?? fallback.now,
  };
};
